import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { authService } from './services/auth-service';
import Login from './pages/Login';
import Subjects from './pages/Subjects';
import Modules from './pages/Modules';
import { Conversation } from './pages/Conversation';
import AdminModules from './pages/AdminModules';
import AdminClasses from './pages/AdminClasses';
import AdminSubjects from './pages/AdminSubjects';
import AdminUsers from './pages/AdminUsers';
import AdminClassUsers from './pages/AdminClassUsers';
import ActivateInvitation from './pages/ActivateInvitation';
import ConfirmClassInvitation from './pages/ConfirmClassInvitation';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AdminConversation from './pages/AdminConversation';
import AdminDays from './pages/AdminDays';
import AdminDayConversations from './pages/AdminDayConversations';
import AdminUserConversations from './pages/AdminUserConversations';
import './App.css';
import './styles/common.css';

// Protected Route Component
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  return authService.isAuthenticated() ? <>{children}</> : <Navigate to="/" replace />;
}

// Teacher-only Protected Route Component
function TeacherRoute({ children }: { children: React.ReactNode }) {
  if (!authService.isAuthenticated()) {
    return <Navigate to="/" replace />;
  }
  
  // Check if user is Teacher
  const token = authService.getToken();
  if (token) {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload.role === 'Teacher') {
        return <>{children}</>;
      }
    } catch (error) {
      // Ungültiges Token wird ignoriert
    }
  }
  
  return <Navigate to="/subjects" replace />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/activate" element={<ActivateInvitation />} />
        <Route path="/confirm-class" element={<ConfirmClassInvitation />} />
        <Route path="/modules" element={
          <ProtectedRoute>
            <Modules />
          </ProtectedRoute>
        } />
        <Route path="/subjects" element={
          <ProtectedRoute>
            <Subjects />
          </ProtectedRoute>
        } />
        <Route path="/admin" element={
          <TeacherRoute>
            <Navigate to="/admin/modules" replace />
          </TeacherRoute>
        } />
        <Route path="/admin/modules" element={
          <TeacherRoute>
            <AdminModules />
          </TeacherRoute>
        } />
        <Route path="/admin/classes" element={
          <TeacherRoute>
            <AdminClasses />
          </TeacherRoute>
        } />
        <Route path="/admin/subjects" element={
          <TeacherRoute>
            <AdminSubjects />
          </TeacherRoute>
        } />
        <Route path="/admin/users" element={
          <TeacherRoute>
            <AdminUsers />
          </TeacherRoute>
        } />
        <Route path="/admin/class-users" element={
          <TeacherRoute>
            <AdminClassUsers />
          </TeacherRoute>
        } />
        <Route path="/admin/days" element={
          <TeacherRoute>
            <AdminDays />
          </TeacherRoute>
        } />
        <Route path="/admin/day-conversations" element={
          <TeacherRoute>
            <AdminDayConversations />
          </TeacherRoute>
        } />
        <Route path="/admin/user-conversations" element={
          <TeacherRoute>
            <AdminUserConversations />
          </TeacherRoute>
        } />
        <Route path="/admin/conversation" element={
          <TeacherRoute>
            <AdminConversation />
          </TeacherRoute>
        } />
        <Route path="/conversation/new/:subjectId" element={
          <ProtectedRoute>
            <Conversation />
          </ProtectedRoute>
        } />
        <Route path="/conversation/:conversationId" element={
          <ProtectedRoute>
            <Conversation />
          </ProtectedRoute>
        } />
      </Routes>
    </Router>
  );
}

export default App;